import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils, { authOptions } from 'api/requestUtils'

type Endpoint = paths['/api/lux-loyalty/earn-decisions']['post']
type Payload = Endpoint['requestBody']['content']['application/json']
type Response = Endpoint['responses']['200']['content']['application/json']

async function requestLoyaltyEarnDecisionEnrolment(payload: Payload): Promise<Array<App.LoyaltyEarnDecision>> {
  const response = await requestUtils.post<Response, Payload>('/api/lux-loyalty/earn-decisions', payload, {
    ...authOptions(),
    excludeBrand: true,
  })
  return response.result
}

export default requestLoyaltyEarnDecisionEnrolment
